import { api } from "../../lib/api";
import { useState } from "react";
import type { FormEvent } from "react";
import type { Account } from "../../types";
import FormActions from "../../components/FormActions";
import DateInput from "../../components/DateInput";
import { todayIn } from "../../lib/finance";

const saveAccount = (body: unknown) => api("settings/accounts/save", body);

export default function CardStatementForm({ account, onSaved, onCancel: _onCancel }: { account: Account; onSaved: () => Promise<unknown>; onCancel?: () => void }) {
  const [statementBalance, setStatementBalance] = useState(account.statementBalance == null ? "" : String(account.statementBalance));
  const [minimumPayment, setMinimumPayment] = useState(account.minimumPayment == null ? "" : String(account.minimumPayment));
  const [statementDueDate, setStatementDueDate] = useState(account.statementDueDate || "");
  const [creditLimit, setCreditLimit] = useState(account.creditLimit == null ? "" : String(account.creditLimit));
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true); setError("");
    try {
      await saveAccount({ ...account, expected: account, openingBalance: String(account.openingBalance ?? account.balance), creditLimit, statementRecordedDate: todayIn(), statementBalance, minimumPayment, statementDueDate });
      await onSaved();
    } catch (reason) {
      setError((reason as Error).message);
    } finally {
      setBusy(false);
    }
  }
  return <form className="statement-form" onSubmit={submit}>
    <p>Enter the values exactly as shown by the card issuer.</p>
    <div className="statement-form-grid">
      <label>Statement balance <small>{account.currency}</small><input inputMode="decimal" required pattern="[0-9]+([.][0-9]{1,2})?" value={statementBalance} onChange={event => setStatementBalance(event.target.value)} /></label>
      <label>Minimum payment <small>{account.currency}</small><input inputMode="decimal" required pattern="[0-9]+([.][0-9]{1,2})?" value={minimumPayment} onChange={event => setMinimumPayment(event.target.value)} /></label>
    </div>
    <label>Statement due date<DateInput required value={statementDueDate} onChange={event => setStatementDueDate(event.target.value)} /></label>
    {!account.creditLimit && <label>Credit limit <small>{account.currency}</small><input inputMode="decimal" required pattern="[0-9]+([.][0-9]{1,2})?" value={creditLimit} onChange={event => setCreditLimit(event.target.value)} /></label>}
    {error && <p className="form-error" role="alert">{error}</p>}
    <FormActions label="Save statement" busy={busy} />
  </form>;
}
